module.exports = __webpack_public_path__ + "img/2_73.30c072d0.png";